export const assessmaxBaseurl = 'https://demoedu.assessmax.com/services';
export const aiBaseURL = 'https://ai.assessmax.com'

export const loginApi = '/api/v1/auth/token';
export const refresh = '/api/v1/token/refresh';
export const resetPassword = '/api/v1/user/reset/password';

export const overviewData = '/api/v1/dashboard/metrics';

export const userList = '/api/v1/user/list';
export const userDetail = '/api/v1/user/detail';
export const userAdd = '/api/v1/user/add';
export const userUpdate = '/api/v1/user/update';
export const passwordSet = '/api/v1/user/password/set';
export const passwordTokenValidate = '/api/v1/user/activate/password/set/';

export const timeZoneList = '/api/v1/timezone/list';
export const roleList = '/api/v1/role/list';

export const departmentList = '/api/v1/department/list';
export const departmentDetail = '/api/v1/department/detail';
export const departmentAdd = '/api/v1/department/add';
export const departmentUpdate = '/api/v1/department/update';

export const programmeList = '/api/v1/programme/list';
export const programmeDetail = '/api/v1/programme/detail';
export const programmeAdd = '/api/v1/programme/add';
export const programmeUpdate = '/api/v1/programme/update';

export const locationList = '/api/v1/location/list';
export const locationDetail = '/api/v1/location/detail/';
export const locationAdd = '/api/v1/location/add';
export const locationUpdate = '/api/v1/location/update';

export const assessmentList = '/api/v1/assessment/list';
export const assessmentAdd = '/api/v1/assessment/add';
export const assessmentDetail = '/api/v1/assessment/detail/';
export const assessmentDelete = '/api/v1/assessment/delete/';
export const assessmentCycleList = '/api/v1/constant/view/assessmentcycle';

export const assessmentTemplateList = '/api/v1/assessment/template/list';
export const assessmentTemplateDetail = '/api/v1/assessment/template/detail/';

export const runAdd = '/api/v1/run/add';
export const validateRunStatusUpdate = '/api/v1/run/status/update/validate';
export const runStatusUpdate = '/api/v1/run/status/update';

export const assignmentList = '/api/v1/assignment/list';
export const assignmentSubmissionAssessmentDetail = '/api/v1/assignment/submission/assessment/detail/';

export const runAssessmentList = '/api/v1/run/assessment/list';
export const runAssessmentClientList = '/api/v1/run/assessment/client/list';
export const responderCountList = '/api/v1/run/assessment/client/responder/count';
export const submitDetail = '/api/v1/run/assessment/client/submit/detail/';

export const resultDetail = '/api/v1/result/detail/';
export const resultUpdate = '/api/v1/result/update';
export const resultBulkPublish = '/api/v1/result/bulk/publish';
export const resultBulkUnPublish = '/api/v1/result/bulk/unpublish';
export const resultCsvDownload = '/api/v1/result/csv/download';

export const takeAssessmentRunList = '/api/v1/take/assessment/run/list';
export const takeAssessmentRunDetail = '/api/v1/take/assessment/run/detail/';
export const takeAssessmentRunDetailToken = '/api/v1/take/assessment/run/detail/token';
export const takeAssessmentRunAnswerAdd = '/api/v1/take/assessment/run/answer/add';
export const takeAssessmentRunUpdate = '/api/v1/take/assessment/run/update';
export const takeAssessmentRunGenerateOTP = '/api/v1/take/assessment/run/generate/otp';
export const takeAssessmentActivity = '/api/v1/take/assessment/run/activity';
export const takeAssessmentRunDeleteAsset = '/api/v1/take/assessment/run/delete/asset';
export const assessmentClinetList = '/api/v1/run/assessment/client/list';

export const aiQuestionGenerate = '/api/v1/ai/generate/questions/text';
export const aiQuestionGeneratepdf = '/api/v1/ai/generate/questions/file';
export const aiQuestionGeneratePrompt = '/api/v1/ai/generate/questions/prompt';
export const aiImageValidation = '/api/v1/ai/image/validation';

export const fileUpload = '/api/v1/file/upload';
export const fileUploadFragment = '/api/v1/file/upload/fragment';
export const fileAssemble = '/api/v1/file/assemble';

export const importUser = '/api/v1/import/clients'

//subject

export const subjectList = '/api/v1/subject/list';
export const subjectDetail = '/api/v1/subject/detail';
export const subjectAdd = '/api/v1/subject/add';
export const subjectUpdate = '/api/v1/subject/update';

//user bulk active
export const userBulkActive = '/api/v1/user/bulk/active'
export const userBulkInactive = '/api/v1/user/bulk/inactive'

// Report list
export const assessmentStatusReport = '/api/v1/reports/run/assessment/status';
export const assessmentGenderReport = '/api/v1/reports/run/assessment/gender/count';
export const assessmentProgramReport = '/api/v1/reports/run/assessment/program/count';

// Report Analytics
export const genderAnalytics = '/api/v1/reports/gender';
export const programmeAnalytics = '/api/v1/reports/programme';
export const departmentAnalytics = '/api/v1/reports/department';

// Responder add
export const responderAdd = '/api/v1/responder/add';

// Responder Link
export const responderLinkToken = '/api/v1/responder/generate/invite/token';
export const responderLinkValidate = '/api/v1/responder/invite/token/validate';

// Code viewer
export const codeRun = '/api/v1/ai/code/run';
